module.exports = __webpack_public_path__ + "static/home-opening-optimized.381a9a93.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/home-opening-optimized.png
// module id = 582
// module chunks = 35783957827783